import { Ellipse, Polygon } from 'fabric';
import { mmToPixels } from './DecalEditorCanvasSizing';
import { formTypes } from '../Components/Editor/Interfaces';
export const ChangeToOval = (canvas) => {
    const zoom = canvas.getZoom();
    const ellipseClipPath = new Ellipse({
        rx: canvas.getWidth() / zoom / 2,
        ry: canvas.getHeight() / zoom / 2,
        left: canvas.getWidth() / zoom / 2,
        top: canvas.getHeight() / zoom / 2,
        originX: 'center',
        originY: 'center',
        id: 'ellipse-form',
    });
    canvas.clipPath = ellipseClipPath;
};
export const ChangeToArrow = (canvas) => {
    const zoom = canvas.getZoom();
    function createArrowPoints(width, height) {
        return [
            // Start near top-left
            { x: 0, y: height * 0.25 },
            // Move horizontally to the left portion
            { x: width * 0.6, y: height * 0.25 },
            // Go up to top
            { x: width * 0.6, y: 0 },
            // Rightmost tip (center)
            { x: width, y: height * 0.5 },
            // Down to bottom
            { x: width * 0.6, y: height },
            // Move horizontally to bottom-left portion
            { x: width * 0.6, y: height * 0.75 },
            // All the way back to left
            { x: 0, y: height * 0.75 },
        ];
    }
    const width = canvas.getWidth() / zoom;
    const height = canvas.getHeight() / zoom;
    const arrowPoints = createArrowPoints(width, height);
    const arrowClipPath = new Polygon(arrowPoints, {
        left: width / 2,
        top: height / 2,
        originX: 'center',
        originY: 'center',
        id: 'arrow-form',
    });
    canvas.clipPath = arrowClipPath;
};
export const ChangeToArrowLeft = (canvas) => {
    const zoom = canvas.getZoom();
    function createArrowLeftPoints(width, height) {
        return [
            // Leftmost tip (center)
            { x: 0, y: height * 0.5 },
            // Go up to top
            { x: width * 0.4, y: 0 },
            // Move horizontally to the right portion
            { x: width * 0.4, y: height * 0.25 },
            // All the way to right
            { x: width, y: height * 0.25 },
            // Down to bottom-right portion
            { x: width, y: height * 0.75 },
            // Move horizontally to bottom-left portion
            { x: width * 0.4, y: height * 0.75 },
            // Bottom of arrow
            { x: width * 0.4, y: height },
        ];
    }
    const width = canvas.getWidth() / zoom;
    const height = canvas.getHeight() / zoom;
    const arrowLeftPoints = createArrowLeftPoints(width, height);
    const arrowLeftClipPath = new Polygon(arrowLeftPoints, {
        left: width / 2,
        top: height / 2,
        originX: 'center',
        originY: 'center',
        id: 'arrow-left-form',
    });
    canvas.clipPath = arrowLeftClipPath;
};
export const ChangeToStopSign = (canvas) => {
    const zoom = canvas.getZoom();
    function createOctagonPoints(width, height) {
        return [
            // Top edge (left corner)
            { x: width * 0.25, y: 0 },
            // Top edge (right corner)
            { x: width * 0.75, y: 0 },
            // Top-right corner
            { x: width, y: height * 0.25 },
            // Right edge
            { x: width, y: height * 0.75 },
            // Bottom edge (right corner)
            { x: width * 0.75, y: height },
            // Bottom edge (left corner)
            { x: width * 0.25, y: height },
            // Bottom-left corner
            { x: 0, y: height * 0.75 },
            // Left edge
            { x: 0, y: height * 0.25 },
        ];
    }
    const width = canvas.getWidth() / zoom;
    const height = canvas.getHeight() / zoom;
    const stopSignPoints = createOctagonPoints(width, height);
    const stopSignClipPath = new Polygon(stopSignPoints, {
        left: width / 2,
        top: height / 2,
        originX: 'center',
        originY: 'center',
        id: 'stop-sign-form',
    });
    canvas.clipPath = stopSignClipPath;
};
export const ChangeToTriangle = (canvas) => {
    const zoom = canvas.getZoom();
    function createTrianglePoints(width, height) {
        return [
            // Top point
            { x: width / 2, y: 0 },
            // Bottom right corner
            { x: width, y: height },
            // Bottom left corner
            { x: 0, y: height },
        ];
    }
    const width = canvas.getWidth() / zoom;
    const height = canvas.getHeight() / zoom;
    const trianglePoints = createTrianglePoints(width, height);
    const triangleClipPath = new Polygon(trianglePoints, {
        left: width / 2,
        top: height / 2,
        originX: 'center',
        originY: 'center',
        id: 'triangle-form',
    });
    canvas.clipPath = triangleClipPath;
};
export const ChangeToRotatedSquare = (canvas) => {
    const zoom = canvas.getZoom();
    function createRotatedSquarePoints(width, height) {
        return [
            // Top point
            { x: width / 2, y: 0 },
            // Right point
            { x: width, y: height / 2 },
            // Bottom point
            { x: width / 2, y: height },
            // Left point
            { x: 0, y: height / 2 },
        ];
    }
    const width = canvas.getWidth() / zoom;
    const height = canvas.getHeight() / zoom;
    const rotatedSquarePoints = createRotatedSquarePoints(width, height);
    const rotatedSquareClipPath = new Polygon(rotatedSquarePoints, {
        left: width / 2,
        top: height / 2,
        originX: 'center',
        originY: 'center',
        id: 'rotated-square-form',
    });
    canvas.clipPath = rotatedSquareClipPath;
};
export const ChangeForm = (canvas, canvasRef, canvasForm, renderAll = true) => {
    if (canvas.clipPath) {
        Reset(canvas);
    }
    const canvasContainer = canvasRef === null || canvasRef === void 0 ? void 0 : canvasRef.parentElement;
    switch (canvasForm.formKey) {
        case formTypes.Oval:
            ChangeToOval(canvas);
            break;
        case formTypes.ArrowRight:
            ChangeToArrow(canvas);
            break;
        case formTypes.ArrowLeft:
            ChangeToArrowLeft(canvas);
            break;
        case formTypes.StopSign:
            ChangeToStopSign(canvas);
            break;
        case formTypes.Triangle:
            ChangeToTriangle(canvas);
            break;
        case formTypes.RotatedSquare:
            ChangeToRotatedSquare(canvas);
            break;
        case formTypes.None:
            Reset(canvas);
            break;
        default:
            break;
    }
    canvas.set({
        'form-id': canvasForm.formKey,
    });
    if (renderAll) {
        canvas.renderAll();
    }
    const boxShadowValue = 'drop-shadow(0 1px 3px rgba(0, 0, 0, 0.2))';
    if (canvasContainer) {
        canvasContainer.style.filter = boxShadowValue;
    }
    if (canvasRef) {
        canvasRef.style.filter = boxShadowValue;
    }
    if (canvasContainer) {
        Array.from(canvasContainer.querySelectorAll('canvas')).forEach((canvasElem) => {
            canvasElem.style.filter = boxShadowValue;
            canvasElem.style.boxShadow = 'none'; // Remove old box-shadow
        });
    }
};
export const Reset = (canvas) => {
    canvas.clipPath = null;
    canvas.getObjects().forEach((object) => {
        if (object.id === 'border-for-path') {
            canvas.remove(object);
        }
    });
    canvas.set({
        'form-id': formTypes.None,
    });
    canvas.renderAll();
};
export const getClipPath = (fabricCanvas, canvasSize) => {
    if (!fabricCanvas.clipPath) {
        return null;
    }
    const realWidthPx = mmToPixels(canvasSize.width);
    const realHeightPx = mmToPixels(canvasSize.height);
    const zoom = fabricCanvas.getZoom();
    if (fabricCanvas.clipPath.type === 'polygon') {
        const clipPath = fabricCanvas.clipPath;
        const points = clipPath.points || [];
        const adjustedPoints = points.map((point) => ({
            x: point.x / zoom + realWidthPx / 2,
            y: point.y / zoom + realHeightPx / 2,
        }));
        return { type: 'polygon', points: adjustedPoints };
    }
    if (fabricCanvas.clipPath.type === 'ellipse') {
        const clipPath = fabricCanvas.clipPath;
        const rx = (clipPath.rx || 0) / zoom;
        const ry = (clipPath.ry || 0) / zoom;
        const centerX = realWidthPx / 2;
        const centerY = realHeightPx / 2;
        const numPoints = 50;
        const points = [];
        for (let i = 0; i < numPoints; i++) {
            const angle = (i / numPoints) * 2 * Math.PI;
            const x = centerX + rx * Math.cos(angle);
            const y = centerY + ry * Math.sin(angle);
            points.push({ x, y });
        }
        return { type: 'ellipse', points };
    }
    return null;
};
